import { RoundType } from "../components/RoundList/types";

export const getRoundType = (
  __typename: string,
  hasPlayerId: boolean
): RoundType => {
  if (__typename === "MemberRound") {
    return hasPlayerId ? "MEMBER" : "MEMBER_HOLD";
  }
  if (__typename === "CustomerRound") {
    return hasPlayerId ? "CUSTOMER" : "UNKNOWN_CUSTOMER";
  }
  if (__typename === "GuestRound") {
    return hasPlayerId ? "GUEST" : "UNKNOWN_GUEST";
  }
  return "MEMBER";
};
